import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetCoordinatesForAddressesAPIError,
  GetCoordinatesForAddressesAPIVariables,
  fetchGetCoordinatesForAddressesAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getCoordinatesForAddressesAPI;

export function useGetCoordinatesForAddressesAPI(
  variables: GetCoordinatesForAddressesAPIVariables,
  opts?: UseQueryOptions<Response, GetCoordinatesForAddressesAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetCoordinatesForAddressesAPIError>(
    queryKeyFn({
      path: '/api/v2/geocoding/coordinates',
      operationId: 'getCoordinatesForAddressesAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetCoordinatesForAddressesAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
